import { render, staticRenderFns } from "./productproviders.vue?vue&type=template&id=7431964c&"
import script from "./productproviders.vue?vue&type=script&lang=js&"
export * from "./productproviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports